import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import { Box } from '@mui/material'
import { EidAutocomplete } from 'packages/eid-controls'
import { Icon } from 'packages/eid-icons'
import { isNilOrEmpty } from 'packages/core'

const ApplicationOptionComponent = EidAutocomplete.getOptionComponent({
    type: 'label',
    labelProp: 'name',
})

const queryParams = {
    take: 20,
}

const getOptionLabel = (option) => option.name

const CSVInboxCategoryFilter = () => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()

    const filter = (
        <Box padding="18px">
            <EidAutocomplete.New
                placeholder={t('Category')}
                url={'/api/CSVInbox/categories'}
                queryParams={queryParams}
                method="GET"
                supportsServerSideSearch={false}
                minCharactersReqForSearch={0}

                getOptionLabel={getOptionLabel}
                dedupingInterval={60000}
                value={state.inboxCategory ? state.inboxCategory : null}
                optionComponent={ApplicationOptionComponent}
                clearIcon={
                    !isNilOrEmpty(state.inboxCategory) && (
                        <Icon
                            name="Close"
                            color="#959598"
                            onClick={() =>
                                dispatch({
                                    type: 'SET_PROP',
                                    payload: {
                                        key: 'inboxCategory',
                                        value: null,
                                    },
                                })
                            }
                        />
                    )
                }
                onChange={(_, value) => {
                    dispatch({
                        type: 'SET_PROP',
                        payload: {
                            key: 'inboxCategory',
                            value: value,
                        },
                    })
                }}
            />
        </Box>
    )

    return (
        <Card
            cardTitle={t('Category')}
            color="#fff"
            collapsible
            expanded={Boolean(state.inboxCategory)}
        >
            {filter}
        </Card>
    )
}

export default CSVInboxCategoryFilter
